import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ProfileDropdown from './ProfileDropdown';
import { useDispatch } from 'react-redux';
import { signOut } from '../../store/actions/authActions';
import DownloadCatalog from '../../main-component/Product/download';
import logoMain from '../../images/Logo/9YearsLogo-transparent.png';
import './header.scss';

const navLinks = [
    { label: 'Home',       to: '/'        },
    { label: 'Products',   to: '/products' },
    { label: 'Request',    to: '/request'  },
    { label: 'Contact Us', to: '/contact'  },
];

const Header = (props) => {
    const push       = useNavigate();
    const dispatch   = useDispatch();
    const [loggedIn,  setLoggedIn]  = useState(false);
    const [scrolled,  setScrolled]  = useState(false);
    const [menuOpen,  setMenuOpen]  = useState(false);

    const decodeToken = (token) => {
        const base64Url = token.split('.')[1];
        const base64    = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const payload   = decodeURIComponent(
            atob(base64).split('').map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')
        );
        return JSON.parse(payload);
    };

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 40);
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    useEffect(() => {
        const onResize = () => { if (window.innerWidth > 960) setMenuOpen(false); };
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            const decoded = decodeToken(token);
            if (decoded.exp * 1000 < Date.now()) {
                setLoggedIn(false);
                dispatch(signOut(push));
            } else {
                setLoggedIn(true);
                const interval = setInterval(() => {
                    const t = localStorage.getItem('token');
                    if (!t) { clearInterval(interval); setLoggedIn(false); return; }
                    const d = decodeToken(t);
                    if (d.exp * 1000 < Date.now()) {
                        setLoggedIn(false);
                        dispatch(signOut(push));
                        clearInterval(interval);
                    }
                }, 60000);
                return () => clearInterval(interval);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleLinkClick = () => {
        window.scrollTo(0, 0);
        setMenuOpen(false);
    };

    return (
        <>
            <header className={`dp-header${scrolled ? ' dp-header--scrolled' : ''}`}>
                <div className="dp-header__inner">
                    {/* Burger — visible only on mobile, stays on LEFT */}
                    <button
                        className={`dp-header__burger${menuOpen ? ' dp-header__burger--open' : ''}`}
                        onClick={() => setMenuOpen(prev => !prev)}
                        aria-label="Toggle navigation"
                    >
                        <span /><span /><span />
                    </button>

                    {/* Logo — centered on mobile via spacer trick */}
                    <Link to="/home" className="dp-header__logo" onClick={handleLinkClick}>
                        <img src={props.Logo} alt="Deep Prabha Transchem" className="dp-header__logo-main" />
                        {/* <img src={logoMain} alt="Anniversary" className="dp-header__logo-badge" /> */}
                    </Link>

                    {/* Desktop nav links */}
                    <nav className={`dp-header__nav${menuOpen ? ' dp-header__nav--open' : ''}`}>
                        {/* Logo shown inside drawer on mobile */}
                        <div className="dp-header__drawer-logo">
                            <img src={props.Logo} alt="Deep Prabha Transchem" />
                            <img src={logoMain} alt="Anniversary" />
                        </div>
                        {navLinks.map(({ label, to }) => (
                            <Link key={to} to={to} className="dp-header__link" onClick={handleLinkClick}>
                                {label}
                            </Link>
                        ))}
                        {loggedIn && (
                            <Link to="/admin-dashboard-secret" className="dp-header__link" onClick={handleLinkClick}>
                                Admin Panel
                            </Link>
                        )}
                        {loggedIn && <ProfileDropdown setLoggedIn={setLoggedIn} />}
                        {/* Download catalog at bottom of drawer on mobile */}
                        <div className="dp-header__catalog-mobile"><DownloadCatalog /></div>
                    </nav>

                    {/* Catalog button — desktop RIGHT side / spacer on mobile */}
                    <div className="dp-header__actions">
                        <div className="dp-header__catalog-desktop"><DownloadCatalog /></div>
                    </div>
                </div>
            </header>
            {menuOpen && (
                <div className="dp-header__overlay dp-header__overlay--visible" onClick={() => setMenuOpen(false)} />
            )}
        </>
    );
};

export default Header;
